import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Pagination } from "../../../../common/pagination";
import ModernPagination from "../../../../common/pagination/ModernPagination";
import Heading from '../../../../common/element/Heading';
import ClientInput from "../../../../common/element/Input/clientInput";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import { debounce } from "../../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../../redux/Admin/breadcrumbsSlice";
import { useDispatch } from 'react-redux';
import AddEditSession from './AddEdit';
import QuizMasterList from './QuizMasterList';
import AddEditQuiz from './AddEdit';

const QuizMaster = () => {
  const [countData, setCountData] = useState(7);
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);

  const [getFilterData, SetFilterData] = useState({
    function_assignment_id: "",
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    search: "",
  });

  // Search Data
  const handleSearch = (e) => {
    SetFilterData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value.trim(),
      };
    });
  };

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Quiz Master",
          url: "/quiz-master",
          home: "/companies",
        },
      ])
    );
  }, []);

  const inputchangehandler = useCallback(debounce(handleSearch), []);

  // Enhanced sample data with all fields
  const sampleDataaa = [
    {
      id: 1,
      sessionName: "React Basics Workshop",
      tool: "Zoom",
      createdBy: "Amit Sharma",
      supportedDocuments: ["Document 1", "Document 2"],
      homeworkActivities: ["Homework Activity 1", "Homework Activity 2"]
    },
    {
      id: 2,
      sessionName: "Node.js Introduction",
      tool: "Google Meet",
      createdBy: "Priya Mehta",
      supportedDocuments: ["Document 2", "Document 3"],
      homeworkActivities: ["Homework Activity 1"]
    },
    {
      id: 3,
      sessionName: "Advanced CSS Techniques",
      tool: "Teams",
      createdBy: "Rahul Verma",
      supportedDocuments: ["Document 1"],
      homeworkActivities: ["Homework Activity 2", "Homework Activity 3"]
    },
    {
      id: 4,
      sessionName: "TypeScript Workshop",
      tool: "Zoom",
      createdBy: "Sneha Reddy",
      supportedDocuments: ["Document 1", "Document 2", "Document 3"],
      homeworkActivities: ["Homework Activity 3"]
    },
    {
      id: 5,
      sessionName: "Fullstack Project Development",
      tool: "Google Meet",
      createdBy: "Arjun Nair",
      supportedDocuments: ["Document 2"],
      homeworkActivities: ["Homework Activity 1", "Homework Activity 3"]
    },
    {
      id: 6,
      sessionName: "Testing in JavaScript",
      tool: "Teams",
      createdBy: "Simran Kaur",
      supportedDocuments: ["Document 3"],
      homeworkActivities: ["Homework Activity 2"]
    },
    {
      id: 7,
      sessionName: "React Hooks Deep Dive",
      tool: "Zoom",
      createdBy: "Rohit Patil",
      supportedDocuments: ["Document 1", "Document 3"],
      homeworkActivities: ["Homework Activity 1", "Homework Activity 2", "Homework Activity 3"]
    },
  ];

  const [allInvoicesData, setAllInvoicesData] = useState(sampleDataaa);

  const handlePageChange = (page) => {
    setfilterpage(page);
    // Add your API call here to fetch data for the new page
    // Example: fetchSessionMasterData(page, filterlimit);
  };

  const filteredData = useMemo(() => {
    if (!getFilterData.search) return sampleDataaa;
    const searchValue = getFilterData.search.toLowerCase();

    return sampleDataaa.filter(
      (item) =>
        item.sessionName.toLowerCase().includes(searchValue) ||
        item.tool.toLowerCase().includes(searchValue) ||
        item.createdBy.toLowerCase().includes(searchValue)
    );
  }, [getFilterData.search]);

  return (
    <React.Fragment>
      <div>
        <p className="text-gray-600 my-3"></p>
      </div>

      <div className="flex justify-between mb-5">
        <div className="w-80 h-10 text-start">
          <Heading> Quiz Master </Heading>
        </div>

        <div className="flex gap-2">
          <BtnPrimary
            onClick={() => setDialogOpen(true)}
            className="h-9 flex items-center justify-center px-3 gap-1"
          >
          Add New Quiz
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.712 4.167v11.666M4.878 10h11.667"
                stroke="#fff"
                strokeWidth="1.667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </BtnPrimary>
        </div>
      </div>

      <div className="flex justify-end mb-4">
        <div className="input-wrapper">
          <div className="input-suffix-start left-3.5">
            <img
              src="/assets/icons-svg/search-lg.svg"
              alt=""
              className="h-5"
            />
          </div>
          <ClientInput
            type="text"
            className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="Search"
            inputchangehandler={inputchangehandler}
            name={"search"}
          />
        </div>
      </div>

      <QuizMasterList sampleData={filteredData} />
     
      <AddEditQuiz
        dialogOpen={dialogOpen}
        onDialogClose={() => setDialogOpen(false)}
      />

      <div className="flex justify-between items-center mt-3">
        {/* Left side - Pagination info */}
        <Pagination
          totalCount={countData}
          pageNumber={filterpage}
          displayPage={allInvoicesData?.length}
          UpdatePageLimit={setfilterlimit}
          UpdatePage={setfilterpage}
        />

        {/* Right side - Modern Pagination Controls */}
        {countData > 0 && totalPages > 1 && (
          <ModernPagination
            totalPages={totalPages}
            currentPage={filterpage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default QuizMaster;